var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z",
    fill: "#3A6AB6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_2183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0981 25.7671C24.1823 24.2153 25.4705 23 27.031 23H28.5424C30.103 23 31.3911 24.2153 31.4754 25.7671L32.5691 45.9172C32.66 47.5921 31.3206 49 29.6362 49H25.9373C24.2528 49 22.9134 47.5921 23.0044 45.9172L24.0981 25.7671ZM32.6977 49H46.0628C47.6849 49 49 47.6904 49 46.075V28.2C49 27.8127 48.7697 27.4622 48.4136 27.3069C48.0574 27.1515 47.6425 27.2209 47.3567 27.4836L40.5147 33.7731V28.2C40.5147 27.8127 40.2845 27.4622 39.9283 27.3069C39.5721 27.1515 39.1572 27.2209 38.8715 27.4836L33.1608 32.733L33.8727 45.847C33.9389 47.0662 33.4803 48.1876 32.6977 49ZM37.251 41.2C37.251 40.482 37.8356 39.9 38.5565 39.9H43.7782C44.4992 39.9 45.0836 40.482 45.0836 41.2V47.05H37.251V41.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_2183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2);
export default __webpack_public_path__ + "static/media/circle-2.8cf2dae746be2f1b511e65beeb1c4548.svg";
export { ForwardRef as ReactComponent };